import React from 'react';
import './WhatWeDo.css';

function WhatWeDo() {
  const focusAreas = [
    {
      title: 'Health-Focused Products',
      description: 'We build and incubate products that solve real-world health and wellness challenges — from daily habits to long-term wellbeing.',
      svg: (
        <svg className="service-icon-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <rect x="20" y="30" width="60" height="50" rx="5" fill="#1976D2" opacity="0.3"/>
          <rect x="25" y="35" width="50" height="40" rx="3" fill="#1565C0" opacity="0.4"/>
          <path d="M50,45 L50,60 M42.5,52.5 L57.5,52.5" stroke="#1565C0" strokeWidth="4" strokeLinecap="round"/>
          <circle cx="35" cy="45" r="3" fill="#1E88E5"/>
          <circle cx="65" cy="45" r="3" fill="#1E88E5"/>
          <rect x="40" y="20" width="20" height="15" fill="#1976D2" opacity="0.5"/>
        </svg>
      )
    },
    {
      title: 'Technology-Driven Solutions',
      description: 'We use technology to simplify, personalize, and scale health solutions without losing the human touch.',
      svg: (
        <svg className="service-icon-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="50" r="35" fill="#1976D2" opacity="0.2"/>
          <path d="M50,20 L50,45 M50,50 L65,65" stroke="#1565C0" strokeWidth="4" strokeLinecap="round"/>
          <circle cx="50" cy="50" r="8" fill="#1565C0"/>
          <circle cx="50" cy="50" r="40" fill="none" stroke="#1E88E5" strokeWidth="2" strokeDasharray="5,5" opacity="0.6"/>
          <circle cx="50" cy="15" r="5" fill="#1976D2"/>
          <circle cx="85" cy="50" r="5" fill="#1E88E5"/>
        </svg>
      )
    },
    {
      title: 'Research & Exploration',
      description: 'We continuously explore emerging ideas, science, and systems that can meaningfully improve human health.',
      svg: (
        <svg className="service-icon-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="35" r="18" fill="none" stroke="#1565C0" strokeWidth="3"/>
          <line x1="53" y1="48" x2="70" y2="65" stroke="#1565C0" strokeWidth="4" strokeLinecap="round"/>
          <circle cx="73" cy="68" r="8" fill="#1976D2" opacity="0.6"/>
          <circle cx="30" cy="30" r="3" fill="#1E88E5"/>
          <circle cx="45" cy="25" r="2" fill="#1976D2"/>
          <circle cx="50" cy="40" r="2" fill="#1565C0"/>
        </svg>
      )
    }
  ];

  return (
    <section id="what-we-do" className="what-we-do-section">
      <div className="container">
        <h2 className="section-title">Our Focus Areas</h2>
        <div className="services-grid">
          {focusAreas.map((area, index) => (
            <div key={index} className="service-card">
              {area.svg}
              <h3 className="service-title">{area.title}</h3>
              <p className="service-description">{area.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhatWeDo;
